import React from "react";
import { FileText, ClipboardCheck, MousePointerClick, ArrowLeft } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: FileText,
    title: "تملأ النموذج",
    desc: "أسئلة قصيرة لتعريفنا بوضعك الحالي. بدون التزام، بدون دفع.",
  },
  {
    n: "02",
    icon: ClipboardCheck,
    title: "نرسل لك تقييماً",
    desc: "نحدد لك المسار الأنسب، أهم خطر، والخطوة التالية الموصى بها.",
  },
  {
    n: "03",
    icon: MousePointerClick,
    title: "تختار ما يناسبك",
    desc: "استشارة بـ 100€ إن كانت تكفي، أو الدعم الكامل بـ 500€ إن كان الأفضل.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="py-16 lg:py-20 bg-white border-t border-slate-100"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-10">
          <div className="text-start max-w-xl">
            <div className="text-emerald-700 text-sm font-semibold mb-3">
              كيف نعمل
            </div>
            <h2 className="font-tajawal text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
              ثلاث خطوات بسيطة قبل أيّ قرار
            </h2>
          </div>
          <p className="text-sm text-slate-500 max-w-md">
            لا تحتاج لاتخاذ قرار اليوم. خطوة بخطوة، حتى يصبح المسار واضحاً.
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            const isLast = i === STEPS.length - 1;
            return (
              <li
                key={step.n}
                className="relative bg-slate-50 border border-slate-200 rounded-2xl p-6 lg:p-7"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-emerald-700 text-white flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="flex-1">
                    <div className="text-xs font-bold text-emerald-700 tracking-widest mb-1">
                      {step.n}
                    </div>
                    <h3 className="font-tajawal text-lg font-bold text-slate-900 mb-1.5">
                      {step.title}
                    </h3>
                    <p className="text-sm text-slate-600 leading-relaxed">
                      {step.desc}
                    </p>
                  </div>
                </div>
                {!isLast && (
                  <ArrowLeft
                    className="hidden md:block absolute top-1/2 -translate-y-1/2 -start-3 w-6 h-6 text-emerald-700 bg-white rounded-full p-1 border border-slate-200"
                    aria-hidden="true"
                  />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
